import { WeatherMoonsetUpIcon } from './WeatherMoonsetUpIcon';

/**
 * author: Jeff Anders
 * id EC4BEC65-5A80-4123-BC47-A4E95524DCDD
 * name weather-moonset-up
 * version: 7.4.47
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/weather-moonset-up.svg
 * tags
 * - Weather 
 */
export const MoonriseIcon = WeatherMoonsetUpIcon;
export default MoonriseIcon